import request from '../utils/request';

const BASE_URL = '/goods-after-sale-service';

const afterSaleServiceApi = {
  // 分页查询售后服务
  pageAfterSaleServices(params = {}) {
    const {
      page = 1, 
      pageSize = 10, 
      sortField = 'create_time', 
      sortOrder = 'desc',
      ...queryParams
    } = params;

    return request.post(`${BASE_URL}/page`, {
      page,
      pageSize,
      sortField,
      sortOrder,
      ...queryParams
    });
  },

  // 创建售后服务
  createAfterSaleService(afterSaleService) {
    return request.post(BASE_URL, afterSaleService);
  },

  // 获取售后服务详情
  getAfterSaleServiceDetail(afterSaleServiceId) {
    return request.get(`${BASE_URL}/${afterSaleServiceId}`);
  },

  // 更新售后服务
  updateAfterSaleService(afterSaleServiceId, afterSaleService) {
    return request.put(`${BASE_URL}/${afterSaleServiceId}`, afterSaleService);
  },

  // 删除售后服务
  deleteAfterSaleService(afterSaleServiceId) {
    return request.delete(`${BASE_URL}/${afterSaleServiceId}`);
  },

  // 审核售后退款申请
  auditAfterSaleRefund(afterSaleServiceId, auditRequest) {
    return request.post(`${BASE_URL}/after-sale/${afterSaleServiceId}/audit`, auditRequest);
  }
};

export default afterSaleServiceApi; 